import type { FestivalConfig } from "./types";

/** A missing edition must never become an event through the typical-date fallback. */
export function isFestivalEditionAvailable(festival: FestivalConfig, year: number): boolean {
  if (festival.paused || festival.excludedYears?.some((entry) => entry.year === year)) return false;
  return !festival.confirmedDatesOnly || Boolean(festival.confirmedDates?.some((entry) => entry.year === year));
}

export const CAMPING_LABEL = {
  "on-site": "On-site camping available",
  "off-site": "Off-site camping available",
  none: "No on-site camping",
  "check-organiser": "Check camping with the organiser",
} as const;
